<template>
  <div class="row">
    <div
      v-for="type in types"
      :key="type.id"
      class="col-xs-12 col-sm-4">
      <div
        :class="type.p"
        class="box p-a"
        @click="onClickSummary(type)">
        <transition 
          name="fade" 
          mode="out-in">
          <div 
            key="content" 
            class="content">
            <div class="pull-left m-r">
              <span :class="type.class">
                <i 
                  class="material-icons" 
                  v-html="type.icon" />
              </span>
            </div>
            <div class="clear">
              <span>
                <h4 class="m-a-0 text-lg _300">
                  {{ Currency != null ? Currency : franchiseCurrency }}
                  <span v-if="!loading">
                    {{ new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(type.total) }}
                  </span>
                  <small 
                    v-show="loading" 
                    class="text-xs">
                    <i class="fa fa-spinner fa-spin fa-2x" />
                  </small>
                </h4>
              </span>
              <small class="text-muted">{{ type.name }}</small>
              <small 
                v-if="type.id === 4" 
                class="view-more">Click to view more</small>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <transition name="slide-in-right">
      <div
        v-if="showOthers"
        class="drawer-overlay"
        @click.self="closeOthers"
      >
        <aside
          class="drawer-panel"
          role="dialog"
          aria-modal="true"
          aria-labelledby="drawerTitle">
          <header class="drawer-header">
            <div>
              <div 
                id="drawerTitle" 
                class="drawer-title">Payment Integrations</div>
              <div class="drawer-subtitle">Listed payment methods for 'Others Transactions'.</div>
            </div>
            <button 
              class="drawer-close" 
              aria-label="Close" 
              @click="closeOthers">
              <span class="material-icons">&#xe5cd;</span>
            </button>
          </header>

          <section class="drawer-body">
            <div 
              v-if="othersLoading" 
              class="drawer-loading">
              <i class="fa fa-spinner fa-spin m-r-sm" /> Loading…
            </div>

            <div 
              v-else-if="othersError" 
              class="drawer-error">
              Unable to load “Others Transactions” details.
              <div class="m-t-sm">
                <a 
                  :href="othersUrl" 
                  class="link-primary">Open full report</a>
              </div>
            </div>

            <ul 
              v-else 
              class="method-list">
              <li
                v-for="m in others"
                :key="m.code || m.name"
                class="method-item"
              >
                <span class="dot" />
                <div class="left-block">
                  <span class="name">{{ m.name }}</span>
                  <span class="pill">Others</span>
                </div>
                <span class="amount">
                  {{ displayCurrency }}
                  {{ new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(m.amount || 0) }}
                </span>
              </li>
            </ul>
          </section>

          <!--          <footer class="drawer-footer">-->
          <!--            <a -->
          <!--              :href="othersUrl" -->
          <!--              class="link-primary">View full report</a>-->
          <!--          </footer>-->
        </aside>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Laravel from '../../laroute';
import Currency from '@js/plugins/currency';

export default {
    props: {
        Currency: { type: String, default: 'RM' },
    },

    data() {
        return {
            loading: true,
            showOthers: false,
            othersLoading: false,
            othersError: false,
            others: [],
            types: [
                {
                    id: 0,
                    name: 'Cash Transactions',
                    total: null,
                    class: 'w-48 rounded accent',
                    icon: '&#xe227;',
                    // url: '/franchise/report/transaction/cash-transactions',
                },
                {
                    id: 1,
                    name: 'Credit Transactions',
                    total: null,
                    class: 'w-48 rounded primary',
                    icon: '&#xe8a1;',
                    // url: '/franchise/report/transaction/credit-transactions',
                },
                {
                    id: 2,
                    name: 'Cheque Transactions',
                    total: null,
                    class: 'w-48 rounded info',
                    icon: '&#xe048;',
                    // url: '/franchise/report/transaction/cheque-transactions',
                },
                {
                    id: 3,
                    name: 'Voucher Transactions',
                    total: null,
                    class: 'w-48 rounded success',
                    icon: '&#xe41d;',
                    // url: '/franchise/report/transaction/voucher-transactions',
                },
                {
                    id: 4,
                    name: 'Others Transactions',
                    total: null,
                    class: 'w-48 rounded warning',
                    icon: '&#xe3f5;',
                    p: 'cursor-point',
                    url: '/franchise/report/transaction/other-transactions',
                },
                {
                    id: -1,
                    name: 'All Transactions',
                    total: null,
                    class: 'w-48 rounded warn',
                    icon: '&#xe8de;',
                    // url: '/franchise/report/transaction/all-transactions',
                },
            ],
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),
        api() {
            return Laravel.route(
                'franchise.report.transaction.getSumTransactionType',
                { id: this.outlet },
            );
        },
        apiOthers() {
            return null;
        },
        othersUrl() {
            return '/franchise/report/transaction/other-transactions';
        },
        outlet() {
            return this.$store.getters.activeOutlet;
        },
        franchiseCurrency() {
            return Currency.hasCurrency();
        },
        displayCurrency() {
            return this.Currency != null
                ? this.Currency
                : this.franchiseCurrency;
        },
    },

    watch: {
        outlet() {
            this.getSumTransaction();
            if (this.showOthers) this.loadOthers();
        },
        dateFilter(a, b) {
            if (a == b) return;
            this.getSumTransaction();
            if (this.showOthers) this.loadOthers();
        },
    },

    mounted() {
        this.getSumTransaction();
        window.addEventListener('keydown', this._escClose);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this._escClose);
    },

    methods: {
        _escClose(e) {
            if (e.key === 'Escape' && this.showOthers) this.closeOthers();
        },

        getSumTransaction() {
            this.loading = true;
            const params = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
            };
            this.$http.get(this.api, { params }).then(res => {
                const data = res.data.data;
                this.types = this.types.map(obj => ({
                    ...obj,
                    total: data[obj.id],
                }));
                this.loading = false;
            });
        },

        onClickSummary(type) {
            if (type.id === 4) {
                this.openOthers();
                return;
            }
            // if (type.url) {
            //     window.location.href = type.url;
            // } else {
            //     alert(`No route defined for ${type.name}`);
            // }
        },

        openOthers() {
            this.showOthers = true;
            this.loadOthers();
        },
        closeOthers() {
            this.showOthers = false;
        },

        _norm(s) {
            return String(s || '')
                .trim()
                .toLowerCase();
        },
        _coalesce(...vals) {
            for (let i = 0; i < vals.length; i++) {
                const v = vals[i];
                if (v !== undefined && v !== null) return v;
            }
            return 0;
        },

        loadOthers() {
            this.othersLoading = true;
            this.othersError = false;

            const params = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
                outlet_id: this.outlet,
                limit: 10000,
            };

            const req = this.apiOthers
                ? this.$http.get(this.apiOthers, { params })
                : this.$http.get(this.othersUrl, {
                      params,
                      headers: {
                          'X-Requested-With': 'XMLHttpRequest',
                          Accept: 'application/json',
                      },
                  });

            req.then(res => {
                const payload = res.data || {};
                const list =
                    payload.data || payload.methods || payload.items || [];

                const normalized = list.map(x => ({
                    name:
                        x.payment_name ||
                        x.name ||
                        x.label ||
                        x.method ||
                        'Unknown',
                    code: x.code || x.key || x.name,
                    amount: Number(this._coalesce(x.sales, 0)),
                }));

                const grouped = {};
                normalized.forEach(item => {
                    const key = this._norm(item.name);
                    if (!grouped[key])
                        grouped[key] = {
                            name: item.name,
                            code: item.code,
                            amount: 0,
                        };
                    grouped[key].amount += isNaN(item.amount) ? 0 : item.amount;
                });

                this.others = Object.values(grouped).sort((a, b) =>
                    a.name.localeCompare(b.name),
                );
                this.othersLoading = false;
            }).catch(() => {
                this.othersLoading = false;
                this.othersError = true;
            });
        },
    },
};
</script>

<style scoped>
.slide-in-right-enter-active,
.slide-in-right-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}
.slide-in-right-enter,
.slide-in-right-leave-to {
    opacity: 0;
    transform: translateX(20px);
}

.view-more {
    float: right;
    color: #6b7280;
    font-size: 12px;
}

.drawer-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.25);
    z-index: 1040;
    display: flex;
    justify-content: flex-end;
}
.drawer-panel {
    width: 460px;
    max-width: 100%;
    height: 100vh;
    background: #fff;
    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
}
.drawer-header {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #e5e7eb;
}
.drawer-title {
    font-weight: 700;
    font-size: 16px;
    color: #111827;
}
.drawer-subtitle {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
}
.drawer-close {
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 6px;
    line-height: 1;
    color: #6b7280;
}
.drawer-body {
    padding: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    flex: 1;
}
.drawer-footer {
    padding: 12px 20px;
    border-top: 1px solid #f1f5f9;
    text-align: left;
}

.drawer-loading,
.drawer-error {
    padding: 14px 20px;
    color: #374151;
}
.link-primary {
    color: #2563eb;
}

.method-list {
    list-style: none;
    margin: 0;
    padding: 0;
}
.method-item {
    display: grid;
    grid-template-columns: 14px 1fr auto;
    align-items: center;
    gap: 12px;
    padding: 14px 20px;
    border-bottom: 1px solid #f3f4f6;
}
.method-item .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ec4899;
}
.left-block {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}
.method-item .name {
    font-weight: 700;
    color: #111827;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.method-item .pill {
    font-size: 12px;
    color: #6b7280;
    background: #f3f4f6;
    border-radius: 999px;
    padding: 2px 8px;
}
.method-item .amount {
    margin-left: auto;
    font-weight: 700;
    color: #374151;
    font-size: 14px;
    letter-spacing: 0.2px;
}

.m-r-sm {
    margin-right: 0.5rem;
}
.m-t-sm {
    margin-top: 0.5rem;
}
.cursor-point {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/sumTransactionType.vue